/* jshint esversion: 6 */
// import 'external';

import $ from 'jquery';
// import throttle from 'lodash/throttle';

export default class JumpOutOfContainer {
    
    /**
     * [consoleLog description]
     *
     * @param {String} log [description]
     *
     * @return {[type]} [description]
     */
    consoleLog(log = '') {
        if (this.debug) {
            console.log('JumpOutOfContainer: ' + log);
        }
    }
    
    /**
     * [constructor description]
     *
     * @param {[type]} options [description]
     *
     * @return {[type]} [description]
     */
    constructor(options) {
        
        this.debug = false;
        
        this.defaults = {
            el: '.jump-out-of-container',
        };
        
        // merge options with defaults
        this.options = $.extend({}, this.defaults, options);
        
        // merge this.option to this
        $.extend(this, this.options);
        
        this.$el = $(this.el);
    }
    
    /**
     * [init description]
     *
     * @return {[type]} [description]
     */
    init() {
        if (this.check()) {
            this.prepare();
            this.run();
        }
    }
    
    /**
     * [check description]
     *
     * @return {[type]} [description]
     */
    check() {
        return this.$el.length;
    }
    
    /**
     * [destroy description]
     *
     * @return {[type]} [description]
     */
    cleanup() {
        
    }
    
    /**
     * [prepare description]
     *
     * @return {[type]} [description]
     */
    prepare() {
        this.consoleLog('prepare [jquery: ' + $().jquery + ']');
        
        this.$window = $(window);
        this.$document = $(document);
    }
    
    /**
     * [run description]
     *
     * @return {[type]} [description]
     */
    run() {
        this.consoleLog('run [jquery: ' + $().jquery + ']');
        this.makeContainer();
    }
    
    /**
     * [onWindowResize description]
     *
     * @return {[type]} [description]
     */
    onWindowResize() {
        if (!this.check()) {
            return;
        }
        this.makeContainer();
    }
    
    /**
     * [makeContainer description]
     *
     * @return {[type]} [description]
     */
    makeContainer() {
        this.consoleLog('make container');
        
        this.$el.css('display', 'block');
        this.$el.css('width', 'auto');
        
        this.offset = (this.$document.width() - this.$el.width()) / 2;
        
        this.$el.css('width', this.$document.width() + 'px');
        // this.$el.css('transform', 'translateX(-' + this.offset + 'px)');
        this.$el.css('left', '-' + this.offset + 'px');
    }
}



// WEBPACK FOOTER //
// ./modules/jump-out-of-container/js/jump-out-of-container.js